<main class="page">
  <app-page-header
    [extraClass]="'page-header--sm'"
    class="page__header page__header--sm"
  >
  </app-page-header>

  <div class="container">
    <section class="page__item">
      <div class="box">
        @if (items) {
          <div class="item text-secondary">
            @if (items?.length) {
              <h2>{{ 'USER_CART_TITLE' | translate }}</h2>
            } @else {
              <h2>{{ 'HAVE_NO_ITEMS_IN_CART' | translate }}</h2>
            }
            <div class="item-box-wrap">
              @for (group of groups; track group; let first = $first) {
                <!-- *ngIf="groups.length > 1" -->
                @if (groups?.length > 1) {
                  <h3 class="mb-2" [ngClass]="first ? 'mt-4' : 'mt-5'">
                    {{ group.period | translate }} {{ group.year | translate }}
                    {{ 'PERIOD_YEAR' | translate | lowercase }}
                  </h3>
                }
                @for (item of group.items; track item) {
                  <div @fadeInOut>
                    <app-cart-item
                      (saveItem)="saveItem($event)"
                      (deleteItem)="deleteItem($event)"
                      [item]="item"
                    >
                    </app-cart-item>
                  </div>
                }
              }
            </div>
          </div>
        } @else {
          <div class="row">
            <div class="col-12 text-center">
              <span
                class="spinner-border spinner-border spinner-border-lg text-secondary"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
          </div>
        }

        @if (items?.length) {
          <div class="item text-secondary">
            <div
              class="cart__preview cart__preview--price float-right mt-4 mb-4 mr-0"
            >
              <h4 class="cart__sub-title">
                <span class="cart__sub-title-sm">
                  {{ 'TOTAL_COUNT_PUBLICATION' | translate }}:
                  {{ total.count }},
                  {{ 'TOTAL_PRICE_PUBLICATION' | translate }}:
                </span>
                <span class="cart__sub-title-lg price-nds">
                  <span class="price-nds__price">
                    {{ total.total | number: '1.2-2' }} {{ 'BYN' | translate }}
                  </span>
                  @if (total.total_include_nds) {
                    <span class="lowercase price-nds__nds cart__sub-title-sm"
                      >{{ 'INCLUDE_NDS_SHORT' | translate }}:
                      {{ total.total_include_nds | number: '1.2-2' }}
                      {{ 'BYN' | translate }}</span
                    >
                  }
                </span>
              </h4>
            </div>
            <div class="cart cart--static cart--column">
              @if (isShowAlert) {
                <div class="cart__container mb-2" @fadeInOut>
                  <div class="bs-component w-100">
                    <div class="alert alert-dismissible alert-warning">
                      <button
                        class="close"
                        data-dismiss="alert"
                        (click)="hideAlert = true"
                        type="button"
                      >
                        ×
                      </button>
                      <h4 class="alert-heading">
                        <strong>{{ 'ATTENTION' | translate }}</strong>
                      </h4>
                      <p class="mb-1 mb-0">
                        {{ 'NEW_ORDERS_COUNT' | translate }} ({{
                          ordersCount
                        }}){{ 'NEW_ORDERS_COUNT_INFO' | translate }}
                      </p>
                    </div>
                  </div>
                </div>
              }
              <div class="cart__container">
                <div class="cart__actions">
                  <button
                    class="button button--outlined"
                    (click)="clear()"
                    [disabled]="isLoading$ | async"
                  >
                    {{ 'CLEAR' | translate }}
                  </button>
                  <button
                    class="button button--filled button--shadow"
                    (click)="pay()"
                    [disabled]="isLoading$ | async"
                  >
                    {{ 'CHECKOUT' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </section>
  </div>
</main>
